import { storyblokEditable } from "@storyblok/react";

const TitleParagraphImage = ({ blok }) => {
  const isDark = blok.dark_background; // toggle for dark bg

  return (
    <section
      {...storyblokEditable(blok)}
      className={`flex flex-col items-center text-center font-['Roboto'] px-4 pt-20 pb-8 transition-colors duration-300 ${
        isDark ? "bg-[#00033E] text-white" : "bg-white text-black"
      }`}
    >
      {/* Title */}
      {blok.title && (
        <h2 className="text-2xl md:text-3xl font-medium mb-4">
          {blok.title}
        </h2>
      )}

      {/* Paragraph */}
      {blok.paragraph && (
        <p
          className={`text-base md:text-lg font-normal max-w-3xl mb-8 ${
            isDark ? "text-gray-200" : "text-gray-700"
          }`}
        >
          {blok.paragraph}
        </p>
      )}

      {/* Image */}
      {blok.image?.filename && (
        <div className="w-full flex justify-center pb-8 md:pb-12">
          <img
            src={blok.image.filename}
            alt={blok.image.alt || "Image"}
            className="w-full max-w-[500px] md:max-w-[700px] lg:max-w-[900px] h-auto object-contain"
          />
        </div>
      )}
    </section>
  );
};

export default TitleParagraphImage;
